export const dom = {};
export function initDomElements() {
    dom.inputText = document.getElementById('inputText');
    dom.mainActionBtn = document.getElementById('mainActionBtn');
    dom.btnText = document.getElementById('btnText');
    dom.sendIcon = document.getElementById('sendIcon');
    dom.btnSpinner = document.getElementById('btnSpinner');
    dom.clearBtn = document.getElementById('clearBtn');
    dom.copyBtn = document.getElementById('copyBtn');
    dom.modelSelector = document.getElementById('modelSelector');
    dom.currentAnonymizedText = document.getElementById('currentAnonymizedText');
    dom.entityBadge = document.getElementById('entityBadge');
    dom.projectList = document.getElementById('projectList');
    dom.chatList = document.getElementById('chatList');
    dom.mobileProjectList = document.getElementById('mobileProjectList');
    dom.mobileChatList = document.getElementById('mobileChatList');
    dom.chatHistory = document.getElementById('chatHistory');
    dom.workflowHeader = document.getElementById('workflowHeader');
    dom.workflowState = document.getElementById('workflowState');
    dom.cancelAnonymizeBtn = document.getElementById('cancelAnonymizeBtn');
    dom.diffTab = document.getElementById('diff-tab');
    dom.anonymizedTab = document.getElementById('anonymized-tab');
    dom.entitiesTab = document.getElementById('entities-tab');
    dom.composeTab = document.getElementById('compose-tab');
    dom.filesTab = document.getElementById('files-tab');
    dom.diffContent = document.getElementById('diffContent');
    dom.anonymizedContent = document.getElementById('anonymizedContent');
    dom.entityMapsContent = document.getElementById('entityMapsContent');
    dom.filesContent = document.getElementById('filesContent');
    dom.modelList = document.getElementById('modelSelectorDropdown');
    dom.selectedModelName = document.getElementById('selectedModelName');
    dom.deleteConfirmTitle = document.getElementById('deleteConfirmTitle');
    dom.deleteConfirmBody = document.getElementById('deleteConfirmBody');
    dom.deleteConfirmBtn = document.getElementById('deleteConfirmBtn');
    dom.byokProviderSelect = document.getElementById('byokProviderSelect');
    dom.byokKeyInput = document.getElementById('byokKeyInput');
    dom.byokAddBtn = document.getElementById('byokAddBtn');
    dom.byokKeysList = document.getElementById('byokKeysList');
    dom.byokKeyCount = document.getElementById('byokKeyCount');
    dom.byokEmptyState = document.getElementById('byokEmptyState');
    dom.byokProviderModels = document.getElementById('byokProviderModels');
    dom.globalSystemPromptInput = document.getElementById('globalSystemPrompt');
    dom.projectSystemPromptInput = document.getElementById('projectSystemPrompt');
    dom.globalMemoryToggle = document.getElementById('globalMemoryToggle');
    dom.globalMemoryScope = document.getElementById('globalMemoryScope');
    dom.projectMemoryToggle = document.getElementById('projectMemoryToggle');
    dom.projectMemoryScope = document.getElementById('projectMemoryScope');
    dom.globalSanitizeOptions = document.getElementById('globalSanitizeOptions');
    dom.globalNerOptions = document.getElementById('globalNerOptions');
    dom.projectSanitizeOptions = document.getElementById('projectSanitizeOptions');
    dom.projectNerOptions = document.getElementById('projectNerOptions');
    dom.projectUseGlobalToggle = document.getElementById('projectUseGlobalToggle');
    dom.projectSettingsTitle = document.getElementById('projectSettingsTitle');
    dom.projectSettingsSubtitle = document.getElementById('projectSettingsSubtitle');
    dom.projectSettingsNotice = document.getElementById('projectSettingsNotice');
    dom.memoryStatusBadge = document.getElementById('memoryStatusBadge');
    dom.autoReviewCheckbox = document.getElementById('autoReviewToggle');
}
